import cx from 'classnames';
import React from 'react';

import img50 from 'images/pro/50.png';
import imgAmazon from 'images/pro/Amazon.png';
import imgCEDB from 'images/pro/CE_DB.png';
import imgGoogle from 'images/pro/Google.png';
import imgMeta from 'images/pro/Meta.png';
import imgProWeekly from 'images/pro/ProWeekly_Landing.svg';
import imgVC from 'images/pro/VC.png';

const ProMarketingCTAs = ({ shouldOverlapPaywall }: { shouldOverlapPaywall?: boolean }) => (
  <div
    id="pro-marketing-ctas"
    className={cx('bg-pink px-16 xs:px-48', {
      '-mt-40 pt-48 pb-32 md:-mt-120 md:pt-152 md:pb-72': shouldOverlapPaywall,
      'py-32 md:py-72': !shouldOverlapPaywall,
    })}
  >
    <div className="md:max-w-1024 mx-auto">
      <p className="font-meta-serif-medium text-headline-pro-sm text-black m-0">
        You{'’'}ll have access to:
      </p>
      <div className="sm:flex justify-between gap-x-44 mt-32 pb-48 md:mt-48 md:pb-64 border-0 border-b-3 border-solid border-white">
        <div className="sm:max-w-458">
          <h3 className="font-meta-serif-medium text-headline-5 text-black m-0">
            Org Chart Library
          </h3>
          <p className="text-paragraph font-meta-serif-normal text-true-black m-0 mt-8">
            Our one-of-a-kind org charts track the thousands of individuals who lead the most
            consequential companies. Use these charts to study your competitors and target
            candidates for recruitment. We add and update org charts monthly.
          </p>
        </div>
        <div className="flex flex-nowrap xs:flex-wrap md:flex-nowrap items-center justify-center gap-x-44 sm:max-w-1/2 mt-16 sm:m-0">
          <div className="w-100 md:w-150">
            <img
              className="block object-contain object-center w-full min-h-50"
              src={imgGoogle}
              alt="Google"
            />
          </div>
          <div className="w-100 md:w-150">
            <img
              className="block object-contain object-center w-full min-h-50"
              src={imgAmazon}
              alt="Amazon"
            />
          </div>
          <div className="w-100 md:w-150">
            <img
              className="block object-contain object-center w-full min-h-50"
              src={imgMeta}
              alt="Meta"
            />
          </div>
        </div>
      </div>
      <div className="sm:flex items-center justify-between gap-x-64 py-48 md:py-64 border-0 border-b-3 border-solid border-white">
        <div className="sm:max-w-458 sm:order-1">
          <h3 className="font-meta-serif-medium text-headline-5 text-black m-0">
            Proprietary Databases and Surveys
          </h3>
          <p className="text-paragraph font-meta-serif-normal text-true-black m-0 mt-8">
            We{'’'}ve gathered unique data points on the most salient sectors of tech—and keep our
            resources up to date through hundreds of hours of reporting each month. You
            {'’'}ll have access to the Creator Economy Database, The Information{'’'}s 50 Most
            Promising Startups, VC Diversity Index and more, along with our monthly subscriber
            survey results.
          </p>
        </div>
        <div className="flex flex-nowrap xs:flex-wrap md:flex-nowrap items-center justify-center gap-x-20 md:gap-x-32 sm:max-w-1/2 mt-24 sm:m-0">
          <div className="w-100 md:w-150">
            <img className="block object-contain w-full" src={img50} alt="The Information 50" />
          </div>
          <div className="w-100 md:w-150">
            <img className="block object-contain w-full" src={imgVC} alt="VC Diversity Index" />
          </div>
          <div className="w-100 md:w-150">
            <img
              className="block object-contain w-full"
              src={imgCEDB}
              alt="Creator Economy Database"
            />
          </div>
        </div>
      </div>
      <div className="sm:flex items-center gap-x-48 pt-48 md:pt-64">
        <div className="sm:max-w-458">
          <h3 className="font-meta-serif-medium text-headline-5 text-black m-0">
            The Information Pro Weekly Wrap
          </h3>
          <p className="text-paragraph font-meta-serif-normal text-true-black m-0 mt-8">
            We{'’'}ll sort through and analyze the most significant updates to our data each week in
            an exclusive newsletter for Pro subscribers.
          </p>
        </div>
        <div className="w-350 sm:w-auto max-w-full mx-auto mt-24 sm:m-0">
          <img className="block object-contain w-full" src={imgProWeekly} alt="" />
        </div>
      </div>
    </div>
  </div>
);

export default ProMarketingCTAs;
